import React from "react";
import {
  SearchConditionData,
  SortTypeData,
  DocumentItemType,
  PaginationData,
} from "../../types";
import { TextOrFileSearchInputData } from "../../pages/SearchPage/similarity/TextOrFileSearchInput";
import {
  searchConditionInitData,
  sortTypeInitData,
  paginationInitData,
} from "./init-data";

/** 類似検索検索データ */
export interface STSearchData {
  // 検索テキスト/ファイル
  input: TextOrFileSearchInputData;
  // ユーザーアクセス履歴ON/OFF
  useUserHistory: boolean;
  // 検索条件データ
  condition: SearchConditionData;
  // 並び順データ
  sort: SortTypeData;
  // ページネーション
  pagination: PaginationData;
}

/** 類似検索コンテキスト型 */
export interface STSearchContextData {
  // 検索前データ（画面と一致する検索データ）
  pending: STSearchData;
  // 検索済データ (検索結果と一致する検索データ)
  searched: STSearchData;

  // 状態
  //  - ready: 未検索
  //  - pending: 検索保留中
  //  - done: 検索完了
  searchStatus: "ready" | "pending" | "done";

  // 検索結果
  searchResult: DocumentItemType[]; // 検索結果

  // 検索条件ドロワー開閉状態
  openSearchConditionDrawer: boolean;

  // 別画面から類似検索する場合のインターフェース
  searchRequest?: {
    id: string; // 文書ID
    filename: string; // ファイル名
  };

  // 備考(デバッグ用)
  description: string;
}

/** 類似検索コンテキスト初期値 */
export const stsearchContextInitData: STSearchContextData = {
  pending: {
    input: {
      text: "",
      file: null,
      doc: {
        id: "",
        name: "",
      },
    },
    useUserHistory: false,
    condition: searchConditionInitData,
    sort: sortTypeInitData,
    pagination: paginationInitData,
  },
  searched: {
    input: {
      text: "",
      file: null,
      doc: {
        id: "",
        name: "",
      },
    },
    useUserHistory: false,
    condition: searchConditionInitData,
    sort: sortTypeInitData,
    pagination: paginationInitData,
  },
  searchStatus: "ready",
  searchResult: [],
  openSearchConditionDrawer: true,
  description: "",
};

/** 類似検索アクションタイプ列挙型 */
export enum STSearchActionType {
  CLEAR = "CLEAR",
  UPDATE = "UPDATE",
}

/** 類似検索アクション型 */
export interface STSearchAction {
  type: STSearchActionType;
  payload?: STSearchContextData;
}

/** 類似検索リデューサー */
export const STSearchReducer: React.Reducer<
  STSearchContextData,
  STSearchAction
> = (state: STSearchContextData, action: STSearchAction) => {
  switch (action.type) {
    case STSearchActionType.CLEAR:
      // 初期値で更新する
      return stsearchContextInitData;
    case STSearchActionType.UPDATE:
      // ディスパッチされた値で更新する
      return {
        ...state,
        ...action.payload,
      };
    default:
      throw Error();
  }
};

/** 類似検索コンテキスト */
export const STSearchContext = React.createContext<STSearchContextData>(
  stsearchContextInitData
);

/** 類似検索ディスパッチャ */
export const STSearchDispatchContext = React.createContext<
  React.Dispatch<STSearchAction> | undefined
>(undefined);
